import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { techStack } from "../data/content";

export default function TechStack() {
  return (
    <section id="stack" className="section">
      <div className="container">
        <Reveal>
          <div className="eyebrow">Tech Stack</div>
          <h2 className="section-title">
            Tools I <span className="gradient-text">reach for daily.</span>
          </h2>
        </Reveal>

        <div style={{ marginTop: 50, display: "flex", flexDirection: "column", gap: 36 }}>
          {Object.entries(techStack).map(([category, items], gi) => (
            <Reveal key={category} delay={gi * 0.08}>
              <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: 24 }} className="stack-row">
                <div style={{ fontFamily: "var(--font-mono)", fontSize: 14, color: "var(--text-dim)", paddingTop: 10 }}>
                  {category}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                  {items.map((item, i) => (
                    <motion.span
                      key={item}
                      initial={{ opacity: 0, scale: 0.85 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: i * 0.04, duration: 0.4 }}
                      whileHover={{ y: -4, borderColor: "var(--accent)", color: "var(--text)" }}
                      style={{
                        padding: "10px 18px",
                        borderRadius: 10,
                        border: "1px solid var(--border)",
                        background: "rgba(14,14,23,0.55)",
                        backdropFilter: "blur(12px)",
                        WebkitBackdropFilter: "blur(12px)",
                        fontSize: 14,
                        color: "var(--text-muted)",
                        fontWeight: 500,
                      }}
                    >
                      {item}
                    </motion.span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .stack-row { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
